import {data} from '../../../data/MeasuringEq'
import {Link} from 'react-router-dom'
const MeasuringEquipment = () => {

  
  return (
    <div>
        <div className='py-6'>
            <h1 className='font-bold text-4xl text-black text-center py-10'>Automation and IT Solution</h1>

            <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-6 p-8'>
               {
                data.map((d) => (
                    <div className='bg-slate-200 p-6 rounded-3xl' key={d.id}>
                        <div className='flex flex-col gap-y-4'>
                        <div className='text-xl font-bold text-black'>{d.title}</div>
                        <div className='font-medium'>{d.description.substring(0,80)+" .........."}</div>
                        </div>
                        <div className='flex justify-end mt-4'><img src={d.Image} alt='imaget' className='w-[300px] h-[200px] rounded-xl'/></div>
                        <div>
                          <Link to={'/detailsabout'}>
                          <button className='px-4 py-2 text-center font-semibold bg-yellow-500 rounded-3xl hover:bg-yellow-400'
                          >Learn More</button>
                          </Link>
                        </div>
                    </div>
                ))
               }
            </div>
        </div>
    </div>
  )
}

export default MeasuringEquipment